import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoreFolder from "../../../../app/core/components/CoreFolder/CoreFolder";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import { useSelector } from "react-redux";
import { FOLDER_NUMBER } from "../../../../utils/constants/tables";
import {
  useGetFolderMacroQuery,
  useGetFoldersCustomQuery,
} from "../../../api/user/userFolders";
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";
import { t } from "i18next";

const FolderMacrocat = () => {
  const navigate = useNavigate();
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const userId = useSelector((state) => state.app.adminId);
  const [foldersCustom, setFoldersCustom] = useState();
  const [selected, setSelected] = useState();
  const [folder, setFolder] = useState();

  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: FOLDER_NUMBER,
  });

  const { data: getMacrocatDoc, isLoading } = useGetFolderMacroQuery();
  const { data: getFoldersCustom } = useGetFoldersCustomQuery({
    page,
    userId: userId,
  });

  useEffect(() => {
    if (selected || folder) {
      navigate("documenti", {
        state: {
          catId: selected.id,
          catName: selected.name,
          folderId: folder,
        },
      });
    }
  }, [selected, navigate, folder]);

  useEffect(() => {
    if (getFoldersCustom) {
      setFoldersCustom(getFoldersCustom?.Data?.items);
    }
  }, [getFoldersCustom]);

  const handleGetExpensecat = (catId) => {
    setSelected(catId);
  };

  const handleGetExpenseFolder = (folId) => {
    setFolder(folId);
  };

  return (
    <div>
      <div className=" w-full flex items-center space-x-20 ">
        <h2>{t("ManageFolders")}</h2>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            color="inherit"
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          >
            {"Tabella"}
          </Link>
          <Typography className="font-semibold " sx={{ color: colorPrimary }}>
            {t("MacroCategory")}
          </Typography>
        </Breadcrumbs>
      </div>
      <div className="flex flex-wrap pt-10">
        {getMacrocatDoc?.Data?.map((el) => (
          <div className="p-4">
            <CoreFolder
              icon={
                <FolderRoundedIcon
                  className="w-20 h-20"
                  style={{ color: colorPrimary }}
                />
              }
              onGetFolder={() => handleGetExpensecat(el)}
              nameFolder={el?.name || "N/A"}
            />
          </div>
        ))}

        {foldersCustom &&
          foldersCustom.map((el) => (
            <div className="p-4">
              <CoreFolder
                icon={
                  <FolderSpecialRoundedIcon
                    className="w-20 h-20"
                    style={{ color: colorPrimary }}
                  />
                }
                nameFolder={el?.name}
                onGetFolder={() => handleGetExpenseFolder(el.id)}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default FolderMacrocat;
